import AssignLessonActionWithDateSelectionV2 from '../../../../lessons/lessonactions/lesson-multi-selection-actions/AssignLessonActionWithDateSelectionV2';
import { useFetchStudentLesson, useHandleTeacherCourseAssigment } from '../StudentLessonsHooks';
import { useGetAssignedStudentCourses } from '../../../../lessons/assigned-student-courses/AssignedStudentCoursesHooks';

export default function StudentAssignLessonAction({
  lessons,
  selectedLessonIds,
  currentStudent,
  selectedDates,
} = {
  lessons: [],
  selectedLessonIds: [],
  currentStudent: null,
  selectedDates: {},
}) {
  const {
    fetchStudentLesson,
  } = useFetchStudentLesson(currentStudent);

  const propsArg = useHandleTeacherCourseAssigment();

  const {
    getAssignedStudentData,
  } = useGetAssignedStudentCourses({
    onStartLoading: null,
    subjectId: propsArg.subjectId,
    onDataLoad: propsArg.onDataLoad,
    assignedStudentCourses: propsArg.assignedStudentCourses,
    filterCriteriaAssignedStudentCourses: propsArg.filterCriteriaAssignedStudentCourses,
  });

  return (
    <AssignLessonActionWithDateSelectionV2
      lessons={lessons}
      buttonLabel='Edit Assignments'
      selectedLessonIds={selectedLessonIds}
      currentStudent={currentStudent}
      showAddToMyList
      reloadDataFunc={() => {
        fetchStudentLesson(false, selectedLessonIds);
        getAssignedStudentData(selectedDates);
      }}
    />
  );
}
